import { AuthenticationStore } from '@/state/authentication.store';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { from, of, switchMap } from 'rxjs';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(AuthenticationStore);

  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const isRefreshTokenRequest = req.url.endsWith('/Authentication/refresh');
  const token = isRefreshTokenRequest
    ? of(store.accessToken()) // Refresh always uses the current access token, even if it is expired
    : from(store.retrieveToken());

  return token.pipe(
    switchMap((token) => {
      if (token) {
        return next(
          req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          }),
        );
      }

      return next(req);
    }),
  );
};
